import React from 'react';
import NewGroupForm from './NewGroupForm';

const ScopeButton = ({ entry, selected, onSelect }) => (
  <button
    type="button"
    className={`td-scope__item${selected ? ' td-scope__item--active' : ''}`}
    aria-current={selected ? 'true' : undefined}
    onClick={() => onSelect(entry.scope)}
  >
    <span className="td-scope__label">{entry.label}</span>
    <span className="td-scope__count">{entry.count}</span>
  </button>
);

/**
 * The scope picker: per organisation, the whole school and each leaving
 * year; then its custom groups with "+ New group"; then its forms and its
 * classes by subject, each shown only when the school has any. `sections`
 * comes from lib/scopes' buildScopeSections, so this component only draws
 * them. `onCreateGroup(organisationId, name)` resolves to an error message
 * or null.
 */
const ScopeSidebar = ({ sections, selectedScope, onSelect, onCreateGroup }) => (
  <aside className="td-scope" aria-label="Students to show">
    {sections.map((section) => (
      <div key={section.organisation.id} className="td-scope__org">
        <div className="td-scope__block">
          <span className="td-eyebrow td-scope__eyebrow">{section.organisation.name}</span>
          {section.entries.map((entry) => (
            <ScopeButton key={entry.scope} entry={entry} selected={entry.scope === selectedScope} onSelect={onSelect} />
          ))}
          {section.studentsWithoutCohort > 0 ? (
            <p className="td-scope__note">
              {section.studentsWithoutCohort} without a leaving year yet
            </p>
          ) : null}
        </div>

        <div className="td-scope__block">
          <span className="td-eyebrow td-scope__eyebrow">Custom groups</span>
          {section.groups.map((entry) => (
            <ScopeButton key={entry.scope} entry={entry} selected={entry.scope === selectedScope} onSelect={onSelect} />
          ))}
          <NewGroupForm
            organisationName={section.organisation.name}
            onCreate={(name) => onCreateGroup(section.organisation.id, name)}
          />
        </div>

        {section.forms.length > 0 ? (
          <div className="td-scope__block">
            <span className="td-eyebrow td-scope__eyebrow">Forms</span>
            {section.forms.map((entry) => (
              <ScopeButton key={entry.scope} entry={entry} selected={entry.scope === selectedScope} onSelect={onSelect} />
            ))}
          </div>
        ) : null}

        {section.subjects.length > 0 ? (
          <div className="td-scope__block">
            <span className="td-eyebrow td-scope__eyebrow">Classes</span>
            {section.subjects.map((subject) => (
              <div key={subject.subject} className="td-scope__subject" role="group" aria-label={subject.subject}>
                <span className="td-scope__subjectname">{subject.subject}</span>
                {subject.classes.map((entry) => (
                  <ScopeButton key={entry.scope} entry={entry} selected={entry.scope === selectedScope} onSelect={onSelect} />
                ))}
              </div>
            ))}
          </div>
        ) : null}
      </div>
    ))}
  </aside>
);

export default ScopeSidebar;
